export const NEGATIVE_FACTOR_EXTERNAL_REDIRECT = 'CS/NEGATIVE_FACTOR/REDIRECT_EXTERNAL';
export const NEGATIVE_FACTOR_CTA_CLICKED = 'CS/NEGATIVE_FACTOR/CTA_CLICKED';
